import { Controller } from 'react-hook-form';
import { InputSize, InputText } from '@ui/src';
import RegulatedCompanyRow from './row';
import { ContactPersonTypes } from './types';
import AdditionalInfoBlock from '../additional-info-block';
import { CustomerStatus } from '../../../../../hoc/common/types';

const ContactPerson = ({
  control,
  clearErrors,
  status,
  errors,
}: ContactPersonTypes) => (
  <AdditionalInfoBlock title="Contact details">
    <>
      <RegulatedCompanyRow title="Contact person name">
        <Controller
          control={control}
          name="contactPersonName"
          defaultValue=""
          render={({ field: { onChange, value, name } }) => (
            <InputText
              name={name}
              placeholder="Enter name..."
              value={value}
              size={InputSize.SMALL}
              onChange={(e) => {
                onChange(e);
                clearErrors(['contactPersonName']);
              }}
              className="borderless"
              disabled={status === CustomerStatus.CLOSED}
              tabIndex={status === CustomerStatus.CLOSED ? -1 : 0}
              error={errors?.contactPersonName?.message}
            />
          )}
        />
      </RegulatedCompanyRow>
      <RegulatedCompanyRow title="Phone number">
        <Controller
          control={control}
          name="phoneNumber"
          defaultValue=""
          render={({ field: { onChange, value, name } }) => (
            <InputText
              name={name}
              placeholder="Enter number..."
              value={value}
              size={InputSize.SMALL}
              onChange={(e) => {
                onChange(e);
                clearErrors(['phoneNumber']);
              }}
              className="borderless"
              disabled={status === CustomerStatus.CLOSED}
              tabIndex={status === CustomerStatus.CLOSED ? -1 : 0}
              error={errors?.phoneNumber?.message}
            />
          )}
        />
      </RegulatedCompanyRow>
      <RegulatedCompanyRow title="Fax number (optional)">
        <Controller
          control={control}
          name="faxNumber"
          defaultValue=""
          render={({ field: { onChange, value, name } }) => (
            <InputText
              name={name}
              placeholder="Enter number..."
              value={value}
              size={InputSize.SMALL}
              onChange={(e) => {
                onChange(e);
                clearErrors(['faxNumber']);
              }}
              className="borderless"
              disabled={status === CustomerStatus.CLOSED}
              tabIndex={status === CustomerStatus.CLOSED ? -1 : 0}
              error={errors?.faxNumber?.message}
            />
          )}
        />
      </RegulatedCompanyRow>
      <RegulatedCompanyRow title="Contact email">
        <Controller
          control={control}
          name="contactEmail"
          defaultValue=""
          render={({ field: { onChange, value, name } }) => (
            <InputText
              name={name}
              placeholder="Enter email..."
              value={value}
              size={InputSize.SMALL}
              onChange={(e) => {
                onChange(e);
                clearErrors(['contactEmail']);
              }}
              className="borderless"
              disabled={status === CustomerStatus.CLOSED}
              tabIndex={status === CustomerStatus.CLOSED ? -1 : 0}
              error={errors?.contactEmail?.message}
            />
          )}
        />
      </RegulatedCompanyRow>
    </>
  </AdditionalInfoBlock>
);

export default ContactPerson;
